import React from "react";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import SolutionEcosystem from "../WebSite/SolutionEcosystem/SolutionEcosystem";
import { Container } from "@material-ui/core";
import OverviewFeatures from "../OverviewFeatures/OverviewFeatures";
import "./AssetMarketplace.css";

// Main component for Asset Marketplace
export default function AssetMarketplace() {
  // Overview Data containing different investment opportunities
  const data1 = [
    "Farming Machinery Investment: Asset Marketplace provides farming machinery investment opportunities as a feature for investors, enabling them to participate in the agricultural sector by funding the acquisition and utilization of farming equipment.",
    "Processing Machinery Investment: Asset Marketplace offers processing machinery investment as a feature, allowing investors to participate in the agricultural sector by funding the acquisition and utilization of machinery for processing agricultural products.",
  ];

  const data2 = [
    "Agri Asset Investment: Agri Asset Investment is offered as a feature by Asset Marketplace, enabling investors to participate in the agricultural sector by funding various agricultural assets such as land, livestock, equipment, and infrastructure.",
  ];

  return (
    <>
      {/* Banner Section */}
      <UpdatesBanner
        className="AssetMarketplace-bg"
        bannerTitle={["Asset Marketplace"]}
        bannerbodycopy="Processing Machinery | Farming Machinery | Agri Assets | Animal | Feed Processing Machinery"
      />

      {/* Overview Section */}
      <SolutionEcosystem title="Overview" type="AssetMarketplace" />

      {/* Overview Features Section */}
      <Container>
        <OverviewFeatures data1={data1} data2={data2} />
      </Container>
    </>
  );
}

